import { defineMessages } from 'react-intl';
import { ShipmentHelperService } from '../../../../../services/shipment-helper-service';
import { FulfillmentPlanOrderGridStatus } from '../../../../../enums/fulfillmentplan-order-grid-status';

const messages = defineMessages({
  resendNotifications: {
    description: 'shipmentDetailsOtherActions.resendNotifications',
    defaultMessage: 'Resend Notifications',
    id: '/r3kvG',
  },
});

export const ResendNotifications = {
  translation: messages.resendNotifications,

  handler: ({ actions }) => {
    const { resendNotifications } = actions;
    resendNotifications();
  },

  shouldBeShown: ({ shipmentStatus, orderGridStatus, enableNewEmailExperience }) => {
    if (enableNewEmailExperience) {
      return false;
    }
    const isShipped = orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;
    return isShipped && ShipmentHelperService.anyNotificationErrored(shipmentStatus);
  },
};
